/* Sticky add-to-cart bar (snippets/buy-buttons.liquid).
   - Re-renders the bar body (thumbnail, variant, price) from the section HTML that
     global.js already fetches on every variant change.
   - Hides the bar when the newly selected variant is sold out (the snippet omits it).
   - Flips the + to a tick for 2s after a successful add, mirroring product-form.js. */
(function () {
  function init() {
    var bars = document.querySelectorAll('[data-sticky-bar]');
    if (!bars.length || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data) return;
      var html = event.data.html;
      bars.forEach(function (bar) {
        if (bar.id !== 'StickyBar-' + event.data.sectionId) return;
        var fresh = html && html.getElementById(bar.id);
        if (!fresh) {
          bar.classList.add('is-unavailable');
          return;
        }
        bar.classList.remove('is-unavailable');
        var body = bar.querySelector('[data-sticky-bar-body]');
        var freshBody = fresh.querySelector('[data-sticky-bar-body]');
        if (body && freshBody) body.innerHTML = freshBody.innerHTML;
      });
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      bars.forEach(function (bar) {
        if (bar.classList.contains('is-added')) return;
        bar.classList.add('is-added');
        setTimeout(function () { bar.classList.remove('is-added'); }, 2000);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
